import { render } from "./TownRead.vue?vue&type=template&id=43884936&scoped=true"
import script from "./TownRead.vue?vue&type=script&lang=js"
export * from "./TownRead.vue?vue&type=script&lang=js"

import "./TownRead.vue?vue&type=style&index=0&id=43884936&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43884936"]])

export default __exports__